<template>
  <div
    class="video-container"
    :id="content.key"
  >
    <el-image
      class="image"
      :id="`${content.key}-1`"
      :src="content.collectionCover.img"
      :style="{
        width: canSetWidth ? content.collectionCover.width : ''
      }"
      @click="videoPlayerShow"
    ></el-image>
    <p
      class="video-title"
      :id="`${content.key}-2`"
      :style="{
        fontFamily: content.collectionCover.titleStyle.fontFamily || '',
        fontSize: (content.collectionCover.titleStyle.fontSize + 'rem') || '',
        lineHeight: (content.collectionCover.titleStyle.lineHeight + 'rem') || '',
        textIndent: (typeof content.titleStyle.textIndent === 'string') ? content.titleStyle.textIndent :
          (typeof content.titleStyle.textIndent === 'number') ? (content.titleStyle.textIndent + 'rem') : '',
        fontWeight: content.collectionCover.titleStyle.fontWeight || '',
        textDecoration: content.collectionCover.titleStyle.underline === 1 ? 'underline' : '',
        fontStyle: content.collectionCover.titleStyle.fontItalic === 1 ? 'italic' : '',
        textAlign: content.collectionCover.titleStyle.textAlign || '',
        color: content.collectionCover.titleStyle.color || '',
        backgroundColor: content.collectionCover.titleStyle.backgroundColor || '',
      }"
    >{{ content.collectionCover.title }}</p>
    <videoPlayer :dialogTitle="dialogTitle" :visible="dialogVisible" :videoList="content.content" @dialogClose="videoPlayerHide"></videoPlayer>
  </div>
</template>

<script>
/*
视频集合的封面样式
*/
import videoPlayer from "../../popup/videoListPlayer.vue";
export default {
  name: "videoUnitCollection",
  components: {
    videoPlayer
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
    canSetWidth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogTitle: '播放视频',
      dialogVisible: false
    }
  },
  methods: {
    videoPlayerShow() {
      this.dialogVisible = true
    },
    videoPlayerHide() {
      this.dialogVisible = false
    },
  }
}
</script>

<style lang="scss" scoped>
.video-container {
  width: 100%;

  .image{
    width: 100%;
    height: auto;
    display: block;
    margin: 0 auto 10rem;
    cursor: pointer;
  }

  .video-title{
    display: block;
    margin-bottom: 10rem;
    width: 100%;
    text-align: center;
    font-size: 16rem;
    color: #00a8ac;
  }
}
</style>